import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import classNames from 'classnames';

import styles from './DialogContent.module.scss';

const DESKTOP_THRESHOLD = 768;

export function DialogContent(props: PropsWithChildren<{ className?: string }>) {
  const [isDesktop, setIsDesktop] = useState(() => {
    const parentWindow = window.parent;

    if (!parentWindow) {
      return false;
    }

    return parentWindow.innerWidth > DESKTOP_THRESHOLD;
  });

  useEffect(() => {
    const parentWindow = window.parent;

    if (!parentWindow) {
      return;
    }

    const handleResize = () => setIsDesktop(parentWindow.innerWidth > DESKTOP_THRESHOLD);

    parentWindow.addEventListener('resize', handleResize);

    return () => parentWindow.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      className={classNames(styles.content, props.className, {
        [styles.desktopContent]: isDesktop,
      })}
    >
      {props.children}
    </div>
  );
}
